<template>
  <section class="main-section">
    <div>
      <h1 class="page-header">{{ pageTitle }}</h1>
    </div>
    <div>
      <slot name="pageContent"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "mainContainer",
  props: {
    pageTitle: {
      type: String,
      required: true
    }
  }
};
</script>
